// extracted by mini-css-extract-plugin
export default {"LoginWrapper":"Login_LoginWrapper__IPgQZ","LoginBgWrapper":"Login_LoginBgWrapper__iw-Cn"};